import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { SelectField } from "../../ui";

interface SelectBancosEmpresaProps {
  name: string;
  methods: any;
  disabled?: boolean;
  required?: boolean;
  label?: string;
}

export function SelectBancosEmpresa({
  name,
  methods,
  disabled = false,
  required = false,
  label = "Selecione um Banco",
}: SelectBancosEmpresaProps) {
  const [bancos, setBancos] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await baseApiService.get("bank-registration/select/bank");
      setBancos(data.data.data);
    };
    fetchData();
  }, []);

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <SelectField
          label={label}
          value={field.value || ""}
          onChange={(e) => field.onChange(e.target.value)}
          required={required}
          disabled={disabled}
        >
          <option value="" />
          {bancos.map((banco) => (
            <option key={banco.id} value={banco.id}>
              {banco.code + " - " + banco.name}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}
